export default "5dce793566f374bd.svg"